// extracted by mini-css-extract-plugin
export var header = "styles-module--header--1nv0f";
export var inner = "styles-module--inner--9A5J7";
export var logo = "styles-module--logo--3et5j";
export var action = "styles-module--action--35tD3";
export var languages = "styles-module--languages--3u0Gy";
export var languagesSelector = "styles-module--languagesSelector--2ElT7";